import {post} from '@/request/request'

/**
 * 区域列表
 * @param data
 * @returns {*}
 */
export function getAreaList(data) {
	return post("o2o.admin.setting.area/getAreaList", data)
}

/**
 * 全部区域和商圈
 * @param data
 * @returns {*}
 */
export function getAreaCircleList() {
	return post("o2o.admin.setting.area/getAreaCircleList", {})
}

/**
 * 添加区域
 * @param data
 * @returns {*}
 */
export function addArea(data) {
	return post("o2o.admin.setting.area/addArea", data)
}

/**
 * 编辑区域
 * @param data
 * @returns {*}
 */
export function editArea(data) {
	return post("o2o.admin.setting.area/editArea", data)
}

/**
 * 删除区域
 * @param data
 * @returns {*}
 */
export function deleteArea(data) {
	return post("o2o.admin.setting.area/deleteArea", data)
}

/**
 * 批量删除区域
 * @param data
 * @returns {*}
 */
export function deleteAreaByIds(data) {
	return post("o2o.admin.setting.area/deleteAreaByIds", data)
}

/**
 * 商圈列表
 * @param data
 * @returns {*}
 */
export function getCircleList(data) {
	return post("o2o.admin.setting.area/getCircleList", data)
}

/**
 * 添加商圈
 * @param data
 * @returns {*}
 */
export function addCircle(data) {
	return post("o2o.admin.setting.area/addCircle", data)
}

/**
 * 编辑商圈
 * @param data
 * @returns {*}
 */
export function editCircle(data) {
	return post("o2o.admin.setting.area/editCircle", data)
}

/**
 * 删除商圈
 * @param data
 * @returns {*}
 */
export function deleteCircle(data) {
	return post("o2o.admin.setting.area/deleteCircle", data)
}


/**
 * 批量删除商圈
 * @param data
 * @returns {*}
 */
export function deleteCircleByIds(data) {
	return post("o2o.admin.setting.area/deleteCircleByIds", data)
}


/**
 * 推广员列表
 * @param data
 * @returns {*}
 */
export function getAreaPromoterList(data) {
	return post("o2o.admin.setting.area/getAreaPromoterList", data)
}


/**
 * 添加推广员
 * @param data
 * @returns {*}
 */
export function addAreaPromoter(data) {
	return post("o2o.admin.setting.area/addAreaPromoter", data)
}


/**
 * 编辑推广员
 * @param data
 * @returns {*}
 */
export function editAreaPromoter(data) {
	return post("o2o.admin.setting.area/editAreaPromoter", data)
}


/**
 * 锁定推广员
 * @param data
 * @returns {*}
 */
export function lockAreaPromoter(data) {
	return post("o2o.admin.setting.area/lockAreaPromoter", data)
}


/**
 * 返回代理商级别列表
 * @param data
 * @returns {*}
 */
export function getPromoterLevelList(data) {
	return post("o2o.admin.setting.area/getPromoterLevelList", data)
}


/**
 * 返回代理商下级代理商列表
 * @param data
 * @returns {*}
 */
export function getSubAreaPromoterList(data) {
	return post("o2o.admin.setting.area/getSubAreaPromoterList", data)
}


/**
 * 根据区域代理商ID获得
 * @param data
 * @return {*}
 */
export function getAreaPPromoters(data) {
	return post("o2o.admin.setting.area/getAreaPPromoters", data);
}


/**
 * 根据商家ID获得TA的区域推广员
 */
export function getStoreAreaPromoters(data) {
	return post("o2o.admin.setting.area/getStoreAreaPromoters", data);
}



